import { render, staticRenderFns } from "./ParcelamentoView.vue?vue&type=template&id=0bc697ef&"
import script from "./ParcelamentoView.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoView.vue?vue&type=script&lang=js&"
import style0 from "./ParcelamentoView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports